<script lang="ts">
    import MoreBtn from "../widgets/moreBtn.svelte"
    import Text from "../widgets/text.svelte"
    export let description = ""
    export let path = ""
    export let bright = false
</script>

<div class="textLink">
    <Text text="{description}" />
    <MoreBtn path="{path}" bright="{bright}" />
</div>

<style lang="less">
    @import "../../assets/css/main.less";
    .textLink {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 20px;
        
    }
</style>
